import { handleActions } from 'redux-actions';
import { USUARIO, LOGOUT } from '../actions';

const stateDefault = {
    tipoDocumento: null, 
    numeroDocumento: null,
    indLogin: false,
    username: null
}

export default  handleActions(
    {
        [USUARIO]: (state, action) => {
            let { tipoDocumento, numeroDocumento, username } = action.payload.custom;
            let indLogin = false;
            
            if(tipoDocumento && numeroDocumento){            
                indLogin = true;
            }else{
                tipoDocumento = null;
                numeroDocumento = null;
                indLogin = false;
                username = null;
            }        
    
            return Object.assign({}, state, { tipoDocumento, numeroDocumento, indLogin, username });
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
  );